customElements.get('select-program') || customElements.define('select-program',
  class extends HTMLElement {
    constructor() {
      super()
      this.yardArea = Number(sessionStorage.getItem("ls-yard-area"));
      this.address = sessionStorage.getItem("ls-address");
      this.grassType = sessionStorage.getItem("ls-grass-type");
      this.variants = JSON.parse(atob((this.dataset.meta))).variants;
    }
    connectedCallback() {
      if (sessionStorage.getItem("ls-address") === null && !window.Shopify.designMode) {
        return window.location.href = "/";
      }
      this.initProgramDetails()
    }

    initProgramDetails() {
      if (this.yardArea === null) {
        console.log("redirect page")
      }

      let variant = this.findVariantID()
      this.fetchVariantInfo(variant)
    }

    findVariantID() {
      return this.variants.find(variant => this.grassType === variant["grass-type"] && this.yardArea >= Number(variant["minimum-area"]) && this.yardArea <= Number(variant["maximum-area"]))
    }

    fetchVariantInfo(variant) {
      fetch(`/products/lawn-care-program?variant=${variant.variantID}&view=${this.grassType}`)
        .then((response) => response.text())
        .then(data => {
          document.querySelector(".ls-select-program__content-wrapper > .loading-overlay__spinner").classList.add('hidden');
          const html = new DOMParser().parseFromString(data, 'text/html')
          this.innerHTML = "";
          this.insertAdjacentElement("beforeend", html.querySelector(".ls-main-product"))
          this.querySelector('#select-program__area').textContent = Intl.NumberFormat('en-US').format(this.yardArea);
          this.querySelector('product-form').querySelector('form').insertAdjacentHTML('afterbegin', `<input id="sqft" type="hidden" name="properties[Sq ft]" value="${Intl.NumberFormat('en-US').format(this.yardArea)}">`)
          document.querySelector(".ls-select-program__background").classList.remove('ls-opacity-0');
        })
        .catch(error => {
          console.log(error)
          alert("Unable to create program at this time.")
        })
    }
  }
)
